import React from 'react';
import { Card } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch } from 'react-redux';
import { getProduct as getProdsByPID } from "features/common/products/productsSlice";

// const productOptionsByGID = {
//   729: [
//     { key: 'Micro', label: 'Cloud Hosting Micro' },
//     { key: 'Starter', label: 'Cloud Hosting Starter' },
//     { key: 'Lite', label: 'Cloud Hosting Lite' },
//     { key: 'SOHO', label: 'Cloud Hosting SOHO' },
//   ],
//   730: [
//     { key: 'Ignite', label: 'Cloud Hosting Ignite' },
//     { key: 'Elevate', label: 'Cloud Hosting Elevate' },
//     { key: 'Ascend', label: 'Cloud Hosting Ascend' },
//     { key: 'Stratos', label: 'Cloud Hosting Stratos' },
//   ],
//   731: [
//     { key: 'CoreX', label: 'Cloud Hosting CoreX' },
//     { key: 'Flexor', label: 'Cloud Hosting Flexor' },
//     { key: 'Optima', label: 'Cloud Hosting Optima' },
//     { key: 'Suprema', label: 'Cloud Hosting Suprema' },
//   ],
// };

const CheckboxNewHosting = ({ productGroup, currentProduct, hostingProduct, setHostingProduct, termin }) => {
  const dispatch = useDispatch();
  const currentGID = currentProduct.current?.gid;
  const currentName = currentProduct.current?.name || '';

  // Handler checkbox
  const handleVelocityChange = (e) => {
    const checked = e.target.checked;
    let match;
    
    if (checked) {
      // Cari produk dengan Velocity
      match = productGroup.find(product =>
        product.name.includes('Cloud Hosting') &&
        product.name.includes(currentName.split(' + ')[0]) &&
        product.name.includes('Velocity')
      );

      if (match) {
        // Update hosting product dengan produk Velocity
        setHostingProduct({
          type: 'SET_CURRENT_PID',
          payload: match.pid
        });
        dispatch(getProdsByPID(match.pid));
      }
    } else {
      // Cari produk tanpa Velocity
      match = productGroup.find(product =>
        product.name.includes('Cloud Hosting') &&
        product.name.includes(currentName.split(' + ')[0]) &&
        !product.name.includes('Velocity')
      );

      if (match) {
        // Update hosting product dengan produk tanpa Velocity
        setHostingProduct({
          type: 'SET_CURRENT_PID',
          payload: match.pid
        });
        dispatch(getProdsByPID(match.pid));
      }
    }
  };

  // Cek apakah produk +Velocity tersedia untuk produk utama yang dipilih
  const velocityAvailable = productGroup.some(
    product =>
      product.name.includes('Cloud Hosting') &&
      product.name.includes(currentName.split(' + ')[0]) &&
      product.name.includes('Velocity')
  );

  // Jika bukan GID yang sesuai atau Velocity tidak tersedia, return null
  if (![729, 730, 731].includes(currentGID) || !velocityAvailable) {
    return null;
  }

  // Ambil billingcycle dari produk aktif
  const billingcycle = currentProduct.current?.billingcycle || hostingProduct.productDetails?.billingcycle || 'monthly';

  // Tentukan harga Addon Velocity
  let velocityPrice = '';
  if (currentGID === 731) {
    // GID 731: harga coret khusus
    if (billingcycle === 'monthly') {
      velocityPrice = '+ Rp850.000';
    } else {
      velocityPrice = '+ Rp10.000.000';
    }
  } else {
    // GID 730 (default sebelumnya)
    switch (billingcycle) {
      case 'annually':
        velocityPrice = '+ Rp550.000';
        break;
      case 'biennially':
        velocityPrice = '+ Rp1.100.000';
        break;
      case 'monthly':
      case 'quarterly':
      case 'semiannually':
      default:
        velocityPrice = '+ Rp50.000';
        break;
    }
  }

  // Cek apakah produk aktif memiliki Velocity
  const isVelocityChecked = currentName.includes(' + Velocity');

  return (
    <Card className="rounded-4 border-0 mb-4">
      <Card.Body className="p-0 mt-3">
        <div className="form-check d-flex align-items-center w-100">
          <input
            type="checkbox"
            className="form-check-input me-3"
            id="velocity_addon"
            checked={isVelocityChecked}
            onChange={handleVelocityChange}
          />
          <label htmlFor="velocity_addon" className="form-check-label flex-grow-1 d-flex align-items-center">
            <span className="fw-bold">Additional Feature Velocity</span>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip>
                  Gratis! Boost CPU hingga 200%, Fitur Advanced untuk Developer, dan GUI Control Panel dari cPanel
                </Tooltip>
              }
            >
              <span
                className="d-inline-block ms-2 fw-bold"
                style={{
                  backgroundColor: "#FFCF96",
                  cursor: "pointer",
                  borderRadius: "50%",
                  fontSize: "15px",
                  color: "#ee4d30",
                  padding: "0px 9px 1px 9px",
                }}
              >
                !
              </span>
            </OverlayTrigger>
          </label>
          <span className="ms-auto text-danger fw-bold" style={{ fontSize: "18px" }}>
            {velocityPrice}
          </span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CheckboxNewHosting;
